//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ActionText, Rating, Typography } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import { MAX_RATING } from '../../../../../constants'
import { REVIEW_COMMENT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from '../../constants'
import CharacteristicInlineBlock from '../CharacteristicInlineBlock'
import Info from '../Info'

import translations from './ReviewItem.translations'

const TEXT_MAX_SIZE = 300

export default {
  components: {
    ActionText,
    CharacteristicInlineBlock,
    Info,
    Rating,
    Typography,
  },
  props: {
    characteristics: {
      type: Array,
      required: true,
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    review: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isCommentHidden: null,
    }
  },
  computed: {
    MAX_RATING: () => MAX_RATING,
    dataSelectorAttribute: () => REVIEW_COMMENT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
    comment() {
      const textExceedMaxSize = this.review.comment.length > this.textMaxSize

      if (!textExceedMaxSize || this.isCommentHidden === false) {
        return this.review.comment
      }

      return this.cropComment(this.review.comment)
    },
    displayInfoOptions() {
      return !isEmpty(this.product) || !isEmpty(this.user)
    },
    hasCharacteristic() {
      return !isEmpty(this.characteristics)
    },
    textMaxSize: () => TEXT_MAX_SIZE,
    translations: () => translations,
  },
  methods: {
    cropComment(comment) {
      this.isCommentHidden = true

      return comment.substring(0, this.textMaxSize).concat('...')
    },
  },
}
